import { render, staticRenderFns } from "./allMedicalLabels.vue?vue&type=template&id=00ffd96a&scoped=true&"
import script from "./allMedicalLabels.vue?vue&type=script&lang=js&"
export * from "./allMedicalLabels.vue?vue&type=script&lang=js&"
import style0 from "../../assets/print.css?vue&type=style&index=0&id=00ffd96a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ffd96a",
  null
  
)

export default component.exports